import React from 'react';
import { useLaunchStrategyContext } from '../../contexts/LaunchStrategyContext';
import { LaunchStrategyContinueBarView } from './LaunchStrategyContinueBarView';
export const LaunchStrategyContinueBarContainer = () => {
    const { showContinueBar, data, progress, absoluteActiveGuideIndex, totalGuides, openModal, setShowContinueBar, } = useLaunchStrategyContext();
    return (React.createElement(LaunchStrategyContinueBarView, { visible: showContinueBar, title: data.modal.categories[progress.category.index].guides[progress.guide.index].title, progressValue: absoluteActiveGuideIndex + 1, maxProgressValue: totalGuides, onClose: () => setShowContinueBar(false), onClick: openModal }));
};
